/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import {
    COMPLETED_BANK_AND_TAX_STATUS,
    COMPLETED_ENROLLMENTS,
    COMPLETED_METADATA,
    COMPLETED_PAYOUT_REPORTS,
    COMPLETED_INVITATIONS
} from "../actions/actions";
import { DataFetchingStatus } from "../enrollment-store/store";
import { Action } from "../actions/actions";

export function dataFetchingStatus(
    state: DataFetchingStatus = new DataFetchingStatus(),
    action: Action
): DataFetchingStatus {
    const newState = { ...state };
    switch (action.type) {
        case COMPLETED_BANK_AND_TAX_STATUS: {
            newState.bankAndTax = true;
            return newState;
        }
        case COMPLETED_ENROLLMENTS: {
            newState.enrollment = true;
            return newState;
        }
        case COMPLETED_INVITATIONS: {
            newState.invitation = true;
            return newState;
        }
        case COMPLETED_PAYOUT_REPORTS: {
            newState.payoutReports = true;
            return newState;
        }
        case COMPLETED_METADATA: {
            newState.metadata = true;
            return newState;
        }
        default:
            return state;
    }
}
